import script from "./SkeletonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonComponent.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonComponent.vue?vue&type=style&index=0&id=367a588c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367a588c"]])

export default __exports__